import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

export enum TourId {
  ANNUAL_REPORT = 'annual_report'
}

export interface TourContextProps {
  tourSteps: number;
  setTourSteps: Dispatch<SetStateAction<number>>;
  activeTourId: TourId | null;
  startTour: (id: TourId) => void;
  endTour: () => void;
}

export const TourContext = createContext<TourContextProps>({} as TourContextProps);

export const TourContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [tourSteps, setTourSteps] = useState(0);
  const [activeTourId, setActiveTourId] = useState<TourId | null>(null);

  const startTour = (id: TourId) => {
    setActiveTourId(id);
    setTourSteps(1);
  };

  const endTour = () => {
    setActiveTourId(null);
    setTourSteps(0);
  };

  return (
    <TourContext.Provider value={{ tourSteps, setTourSteps, activeTourId, startTour, endTour }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTourContext = () => useContext(TourContext);
